import { render, staticRenderFns } from "./TerrainFeatureLayer.vue?vue&type=template&id=020b2e64&"
import script from "./TerrainFeatureLayer.vue?vue&type=script&lang=js&"
export * from "./TerrainFeatureLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports